<template>
  <div class="minwidth w100 mw100" style="background-color: #151419;color: #fff;">
    <tabbar></tabbar>

    <div class="positionrel w100">
      <img style="width: 100%;height: auto;-webkit-filter: contrast(90%);filter: contrast(90%);"
        :src="require('../../public/img/main/login_banner.png')" />
    </div>

    <div class="pcScreen" style="width: 30%;margin: 0 auto;padding: 3% 0;font-size: max(10px,1vw);height: 12em;">
      <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;align-items: center;">
        <div style="width: 20%;">
          账号：
        </div>
        <input style="width: 50%;display: block;line-height: 1.5;" type="text">
      </div>
      <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;align-items: center;margin-top: 2%;">
        <div style="width: 20%;">
          密码：
        </div>
        <input style="width: 50%;display: block;line-height: 1.5;" type="text">
      </div>
      <div
        style="width: 60%;margin: 0 auto;text-align: center;background-color: #f8c661;line-height: 2.2;border-radius: 1em;margin-top: 4%;color: #fff;">
        注册
      </div>
    </div>

    <div class="mobileScreen" style="width: 90%;margin: 0 auto;padding: 3% 0;font-size: 3vw;height: 60vh;">
      <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;align-items: center;">
        <div style="width: 10%;">
          账号：
        </div>
        <input style="width: 50%;display: block;line-height: 1.5;" type="text">
      </div>
      <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;align-items: center;margin-top: 2%;">
        <div style="width: 10%;">
          密码：
        </div>
        <input style="width: 50%;display: block;line-height: 1.5;" type="text">
      </div>
      <div
        style="width: 60%;margin: 0 auto;text-align: center;background-color: #f8c661;line-height: 2.2;border-radius: 1em;margin-top: 4%;color: #fff;">
        注册
      </div>
    </div>

    <bottom></bottom>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        num: 0,
      };
    },

    mounted() {
      this.num = this.$route.query.num;
    },

    methods: {
      gotoNewsDetail(num) {
        this.$router.push({ path: '/newsDetail', query: { num: num } })
      }
    },


  };
</script>

<style scoped>
  .w100 {
    width: 100%;
  }

  .minwidth {
    min-width: 1000px;
  }

  .positionrel {
    position: relative;
    overflow: hidden;
  }

  .pcScreen {
    display: block;
  }

  .mobileScreen {
    display: none;
  }

  @media screen and (max-width: 750px) {
    .pcScreen {
      display: none;
    }

    .mobileScreen {
      display: block;
    }

    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }

    .positionrel {
      position: relative;
      overflow: hidden;
    }
  }
</style>